 <!-- BANNER SECTION START -->
 <div class="home-banner-section">
    <div class="home-slider-item">
      <div class="slider-item">
        <div class="container">
          <div class="slider-item-info">
            <div class="slider-item-img-wrap">
              <img src="assets/img/landing-pages/OSCAL.png" alt="">
            </div>
            <div class="slider-item-details-wrap">
              <h1>Start Your OSCAL Journey With RegScale</h1>
              <p>Partner with RegScale to streamline compliance</p>
              <a class="btn-link" href="https://go.regscale.com/RegScale-Create-Account"> Options for getting started →</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BANNER SECTION END -->

  <!-- ABOUT SECTION START -->
  <div class="about-section">
    <div class="container">
      <div class="about-section-inner">
        <div class="relationships-left-block about-col6">
          <div class="heading">
            <h2>Why We’re Excited About OSCAL.</h2>
          </div>
          <div class="about-para-box">
              <p>The Open Security Controls Assessment Language (OSCAL), developed by NIST, is a set of formats expressed in XML, JSON, and YAML. These formats provide machine-readable representations of control catalogues, control baselines, system security plans, and assessment plans and results. OSCAL transitions the legacy approach to security plan generation and management (Word and Excel documents) to a data-centric approach based on common data standards such as XML/JSON which are more suited for automation.</p>
          </div>
        </div>
        <div class="relationships-right-block about-col6">
          <div class="heading">
            <h2>RegScale 101</h2>
          </div>
          <div class="about-para-box">
              <p>RegScale brings compliance into the modern era through digitization and automation in order to increase scalability while lowering risk, cost, time, and labor. The platform helps organizations move from a manual compliance process to an API-centric, automated approach while keeping compliance documentation continuously up to date. The collaborative capabilities of the platform allow all stakeholders and data owners in the compliance process to work together across platforms to fulfill reporting requirements more quickly and accurately.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ABOUT SECTION END -->

  <!-- ATO PROGRES SECTION START -->
  <div class="ato-progres-section">
    <div class="container">
      <div class="heading">
        <h3>How RegScale Leverages OSCAL to Deliver Compliance Automation</h3>
        <p>RegScale is an early adopter and advocate of the OSCAL standard, released by NIST in 2021. Our platform is purpose-built for security and compliance automation and we view OSCAL as a standards-based foundation for developing our technology and other automation solutions in the future.</p>
        <p>RegScale provides tools for creating OSCAL content included in our free Community Edition (CE). Our platform currently includes support and tools to develop OSCAL content for Catalogues, Profiles, System Security Plans (SSPs), Components, Security Assessment Plans (SAPs), Security Assessment Reports (SARs), and Plans of Action and Milestones (POAMs).</p>
        <p>As we talk to our customers and other compliance professionals, they are excited about the potential for OSCAL but don't know where to begin. To help eliminate this friction, RegScale provides an intuitive Graphical User Interface (GUI) to build artifacts using our wizards and then easily export them as valid OSCAL.</p>
      </div>
      <div class="ato-progres-wrap full-ato-progres-item">
        <div class="ato-progres-item ">
          <div class="ato-progres-info">
            <div class="ato-progres-img-wrap">
                <img src="assets/img/team/howerton.png" alt="Travis Howerton" />
            </div>
            <div class="ato-progres-info-wrap">
              <p> <em>“We are in the very early days of seeing what OSCAL will ultimately become, but the possibilities are endless.  We hope that the tools we provide will accelerate our customers OSCAL journey and provide immediate and tangible value to their security automation and continuous compliance programs.” </em></p>
              <p> <strong>- Travis Howerton, co-founder and CTO, RegScale.</strong> </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- ATO PROGRES SECTION END -->

  <!-- WHERE GO FROM HERE SECTION START -->
  <div class="where-go-section">
    <div class="container">
      <div class="where-go-wrap">
        <div class="heading">
          <h4>Where do we go from here?</h4>
        </div>
        <a href="https://go.regscale.com/RegScale-Create-Account" title="Options for getting started" class="btn-red">Options for getting started →</a>
      </div>
    </div>
  </div>
  <!-- WHERE GO FROM HERE SECTION END -->

    <!-- WORK SECTION START -->
    <div class="work-section mb-5">
        <div class="container">
            <div class="heading">
                <h5>Want to become a partner?</h5>
                <p>
                    Join our ecosystem of partners to make the world a safer place through compliance.
                    No<br>contribution is too small and together, we can all make a difference and reimagine a better<br/>
                    world where compliance is cheaper, easier, and more effective
                </p>
                <a [routerLink]="['/partnership']" title="Options for getting started" class="btn-gray">Options for getting started →</a>

            </div>
        </div>
    </div>
    <!-- WORK SECTION END -->

